import type { FC } from 'react';
import { useMemo } from 'react';
import { BillCheckBold } from 'solar-icons';
import { useAppSelector } from '@/Module/Store/Hook';
import { SubscriptionCourseEmpty, SubscriptionHistoryPrevious } from '@/Module/Subscription/Component';
import { selectedSubscriptionV2UserActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionV2UserActiveSelector';
const SubscriptionLessonSingle: FC = () => {
  const listSubscriptionActive = useAppSelector(state => selectedSubscriptionV2UserActiveSelector(state));
  const data = useMemo(() => {
    return listSubscriptionActive.filter(item => item.subscriptionType === 'فروشگاهی');
  }, [listSubscriptionActive]);
  if (!data.length) return <SubscriptionCourseEmpty />;
  return <div data-sentry-component="SubscriptionLessonSingle" data-sentry-source-file="SubscriptionLessonSingle.tsx">
      <div>
        <div className="flex flex-row ">
          <BillCheckBold className="ml-2 text-blackSix" data-sentry-element="BillCheckBold" data-sentry-source-file="SubscriptionLessonSingle.tsx" />
          <div className="font-semibold text-blackFive ">تک درس های من</div>
        </div>
        <div className="mt-2 text-sm text-blackThree">
          در این صفحه می‌توانید لیست تک درس های خریداری شده خود را مشاهده کرده و به تماشای آنها بپردازید.
        </div>
      </div>
      <SubscriptionHistoryPrevious single data-sentry-element="SubscriptionHistoryPrevious" data-sentry-source-file="SubscriptionLessonSingle.tsx" />
    </div>;
};
export default SubscriptionLessonSingle;